import { ModuloListagem } from "../types";

export function potenciaTotalMenorQuePotenciaMinima(moduloSelecionado: ModuloListagem | null){
  if (!moduloSelecionado) return {status: false, potenciaMinima: 0};

  const moduloPotenciaMinima = moduloSelecionado?.potenciaMinima || 0
  if (!moduloPotenciaMinima) return { status: false, potenciaMinima: 0 }
  
  const potenciaTotalInWatts = Number(moduloSelecionado?.quantidade || 0) * Number(moduloSelecionado?.potencia ||0)
  const potenciaTotalInKw = potenciaTotalInWatts / 1000
  
  if (potenciaTotalInKw > moduloPotenciaMinima) return {status: false, potenciaMinima: 0}
  
  return {status: true, potenciaMinima: moduloPotenciaMinima}
}